import type {MCFetcher} from '@github-ui/ahp-relay/mission-control/mission-control-environment-client'
import {fetchCAPI} from './fetch-capi'

/** Mission Control fetcher backed by the agent-sessions CAPI client. */
export const mcFetcher: MCFetcher = (path: string) => fetchCAPI({path, additionalHeaders: {Accept: 'application/json'}})
